/**
 * NotificationService
 * Service for Notification entity operations
 * Route: api/notification
 * Controller: NotificationController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * NotificationService
 * Handles notification CRUD operations
 * Maps to /api/notification endpoint
 */
export class NotificationService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? NotificationService.DEFAULT_SERVICE_PATH,
            basePath: NotificationService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
NotificationService.DEFAULT_SERVICE_PATH = 'procurements';
NotificationService.BASE_PATH = 'api/notification';
//# sourceMappingURL=NotificationService.js.map